import React from "react";

import ReplyIcon from '@mui/icons-material/Reply';
import { IconButton, colors } from "@mui/material";

type Props = React.ComponentProps<typeof IconButton>;

const ReplyIconButton: React.FC<Props> = (props) => {
  return (
    <IconButton sx={{ padding: "2px" }} {...props}>
      <ReplyIcon
        fontSize="small"
        sx={{ color: colors.grey }}
      />
    </IconButton>
  );
};

export default ReplyIconButton;
